import axios from "axios";

export const GET_GC_LIST = "GET_GC_LIST";
export const DELETE_GC = "DELETE_GC";
export const GET_GC_DETAIL = "GET_GC_DETAIL";
export const POST_GC_CREATE = "POST_GC_CREATE";


export const getGCList = () => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Costo")
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_GC_LIST,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_GC_LIST,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const deleteGC = (data, id) => {

    return (dispatch) => {

        //console.log("ACTION deleteGC");

        axios
            .put(
                "/api/Costo/BorrarGC/" + id, data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: DELETE_GC,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: DELETE_GC,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

};

export const getGCDetail = (id) => {

    //console.log("----->ingresa getGCDetail");

    return (dispatch) => {
        axios
            .get(
                "/api/Costo/ObtieneCostoPorId?id=" + id
            )
            .then(function (response) {
                //console.log(response.data);

                dispatch({
                    type: GET_GC_DETAIL,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: GET_GC_DETAIL,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH
}; //END DETAIL

export const postGCCreate = (data) => {

    //console.log(data);

    return (dispatch) => {
        axios
            .post(
                "/api/Costo", data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: POST_GC_CREATE,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: POST_GC_CREATE,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };

};
